import { AccordionHeader } from './accordion-header';
import { AccordionHeaderContent } from './accordion-header-content';
import { AccordionHeaderTrigger } from './accordion-header-trigger';
import { AccordionItem } from './accordion-item';
import { AccordionPanel } from './accordion-panel';
import { AccordionRoot } from './accordion-root';

export const Accordion = {
  Root: AccordionRoot,
  Item: AccordionItem,
  Header: AccordionHeader,
  HeaderContent: AccordionHeaderContent,
  HeaderTrigger: AccordionHeaderTrigger,
  Panel: AccordionPanel,
};
